/** Is this page served by a local host, the Teacher Computer app (STORY-089 M2)?
 *
 * Yes in the desktop shell, and on a page holding a local host token (`lt.`): a phone's
 * browser paired with that app. Answered from what the page already holds, with no request,
 * so it is right from the first render; `useLocalHost()` in `live/host.ts` asks the host over
 * the network instead and stays as it is. Nobody can set a local host's curriculum flags, so a
 * screen that a cloud flag gates shows here without it (STORY-089, STORY-088, STORY-086). */
import { accessToken, isLocalToken } from "../auth/session";
import { capabilities } from "./capabilities";

export const localHostFrom = (desktop: boolean, token: string | null): boolean => desktop || isLocalToken(token);

export const isLocalHost = (): boolean => localHostFrom(capabilities.desktop, accessToken());
